export const R_URL = 'https://r.stripe.com/0';
export const QA_R_URL = 'https://qa-r.stripe.com/0';
